import {CLStore} from 'common/src/redux/store';
import initializeCreativeTemplatesAgents from './initializeCreativeTemplatesAgents';

function initializeCreativeTemplates(store: CLStore) {
  initializeCreativeTemplatesAgents(store);
}

export default initializeCreativeTemplates;
